import React from 'react'
import BulkActions from "./BulkActions";

function ListCustomerTableHead(props) {
    const {onCheckALl, selectAll, arrSelected} = props

    const _handleChangeChecked = (e) => {
        const {checked} = e.target

        if (typeof onCheckALl === 'function') {
            onCheckALl(checked)
        }
    }

    return <thead className="TableHead">
    <tr>
        <th className="bulkActions">
            <BulkActions selectAll={selectAll} arrSelected={arrSelected} onChange={_handleChangeChecked}/>
        </th>
        <th className="colItem">Tên danh sách</th>
        <th className="colItem">Số lượng KH</th>
        <th className="colItem">Ngày tạo</th>
        <th className="colItem">Người tạo</th>
    </tr>
    </thead>
}

export default ListCustomerTableHead
